module.exports = __webpack_public_path__ + "static/guest-viewer-12461dd113577c074c236660b5e96cb8.gif";